/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping your custom
* Javascript in this file will make it easier to update Broadcast.
*/

(function() {
  // Ouverture immédiate du clavier lorsque la recherche mobile s'ouvre
  document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) return;

    const searchToggle = event.target.closest(
      'header-search-popdown [data-popdown-toggle]'
    );

    if (!searchToggle) return;

    const searchComponent = searchToggle.closest(
      'header-search-popdown'
    );

    const searchDetails = searchToggle.closest('details');

    const searchInput = searchComponent
      ? searchComponent.querySelector(
          '.search-popdown input[type="search"]'
        )
      : null;

    if (!searchDetails || !searchInput) return;

    /*
     * Le gestionnaire de Broadcast est exécuté avant celui-ci.
     * Lors de l'ouverture, l'attribut open est donc déjà présent.
     *
     * Lors de la fermeture, Broadcast lui donne la valeur "false".
     */
    if (
      !searchDetails.hasAttribute('open') ||
      searchDetails.getAttribute('open') === 'false'
    ) {
      return;
    }

    /*
     * Broadcast utilise ensuite open="true" dans sa transition.
     * On l'applique immédiatement pour que le champ soit visible
     * avant de lui donner le focus.
     */
    searchDetails.setAttribute('open', 'true');

    /*
     * Focus exécuté pendant le clic de l'utilisateur :
     * cela permet à Safari iOS d'ouvrir le clavier.
     */
    try {
      searchInput.focus({
        preventScroll: true
      });
    } catch (error) {
      searchInput.focus();
    }

    /*
     * Si une ancienne recherche est encore présente,
     * le curseur est replacé à la fin.
     */
    try {
      const cursorPosition = searchInput.value.length;

      searchInput.setSelectionRange(
        cursorPosition,
        cursorPosition
      );
    } catch (error) {
      // Rien à faire si le navigateur ne supporte pas cette méthode.
    }
  });
  /*
   * Ajoute un espace sous les résultats de recherche correspondant
   * à la hauteur du clavier mobile.
   */
  const searchInputSelector =
    'header-search-popdown .search-popdown input[type="search"]';

  const searchResultsSelector =
    'header-search-popdown [data-predictive-search-results]';

  const searchToggleSelector =
    'header-search-popdown [data-popdown-toggle]';

  const searchCloseSelector =
    'header-search-popdown [data-popdown-close]';

  let searchViewportBottom = window.visualViewport
    ? window.visualViewport.height + window.visualViewport.offsetTop
    : window.innerHeight;

  function updateSearchKeyboardSpace() {
    const resultsContainers = document.querySelectorAll(
      searchResultsSelector
    );

    if (!resultsContainers.length) return;

    /*
     * Aucun ajout sur ordinateur.
     */
    if (!window.matchMedia('(max-width: 749px)').matches) {
      resultsContainers.forEach(function(results) {
        const basePadding = Number(
          results.dataset.searchBasePaddingBottom || 0
        );

        results.style.paddingBottom = basePadding + 'px';
      });

      return;
    }

    const searchInput = document.querySelector(
      searchInputSelector
    );

    const searchIsFocused =
      searchInput &&
      document.activeElement === searchInput;

    const currentViewportBottom = window.visualViewport
      ? window.visualViewport.height +
        window.visualViewport.offsetTop
      : window.innerHeight;

    /*
     * Différence entre l'écran visible avant et après
     * l'apparition du clavier.
     */
    const hiddenHeight = searchIsFocused
      ? Math.max(
          0,
          searchViewportBottom - currentViewportBottom
        )
      : 0;

    /*
     * Les petits changements de hauteur correspondent généralement
     * à la barre d'adresse Safari et non au clavier.
     */
    const keyboardSpace =
      hiddenHeight > 120
        ? hiddenHeight + 24
        : 0;

    resultsContainers.forEach(function(results) {
      /*
       * Mémorise le padding original du thème une seule fois.
       */
      if (!results.dataset.searchBasePaddingBottom) {
        results.dataset.searchBasePaddingBottom =
          parseFloat(
            window.getComputedStyle(results).paddingBottom
          ) || 0;
      }

      const basePadding = Number(
        results.dataset.searchBasePaddingBottom
      );

      results.style.boxSizing = 'border-box';
      results.style.paddingBottom =
        basePadding + keyboardSpace + 'px';
    });
  }

  /*
   * Mémorise la hauteur visible juste avant que le clavier
   * ne commence à apparaître.
   */
  document.addEventListener(
    'pointerdown',
    function(event) {
      if (!(event.target instanceof Element)) return;

      const searchToggle = event.target.closest(
        searchToggleSelector
      );

      if (!searchToggle) return;

      searchViewportBottom = window.visualViewport
        ? window.visualViewport.height +
          window.visualViewport.offsetTop
        : window.innerHeight;
    },
    true
  );

  /*
   * Safari signale l'ouverture du clavier grâce
   * aux événements du visualViewport.
   */
  if (window.visualViewport) {
    window.visualViewport.addEventListener(
      'resize',
      updateSearchKeyboardSpace
    );

    window.visualViewport.addEventListener(
      'scroll',
      updateSearchKeyboardSpace
    );
  }

  document.addEventListener('focusin', function(event) {
    if (
      event.target instanceof Element &&
      event.target.matches(searchInputSelector)
    ) {
      requestAnimationFrame(updateSearchKeyboardSpace);
    }
  });

  document.addEventListener('focusout', function(event) {
    if (
      event.target instanceof Element &&
      event.target.matches(searchInputSelector)
    ) {
      setTimeout(function() {
        updateSearchKeyboardSpace();

        searchViewportBottom = window.visualViewport
          ? window.visualViewport.height +
            window.visualViewport.offsetTop
          : window.innerHeight;
      }, 250);
    }
  });

  document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest(searchCloseSelector)) {
      setTimeout(updateSearchKeyboardSpace, 100);
    }
  });

  window.addEventListener('orientationchange', function() {
    setTimeout(function() {
      searchViewportBottom = window.visualViewport
        ? window.visualViewport.height +
          window.visualViewport.offsetTop
        : window.innerHeight;

      updateSearchKeyboardSpace();
    }, 300);
  });

})();
